interface CustomStyles {
  container: (baseStyles: any, state: any) => any;
  indicatorSeparator: (baseStyles: any, state: any) => any;
  dropdownIndicator: (baseStyles: any, state: any) => any;
  control: (baseStyles: any, state: any) => any;
  menu: (baseStyles: any, state: any) => any;
  option: (baseStyles: any, state: any) => any;
  singleValue: (baseStyles: any, state: any) => any;
  valueContainer: (baseStyles: any, state: any) => any;
  menuList: (baseStyles: any, state: any) => any;
  input: (baseStyles: any, state: any) => any;
}

const CustomStyles = (error: boolean): CustomStyles => {
  const borderColor = error ? '#F00' : 'rgba(29, 41, 61, 0.50)'
  return ({
    container: (baseStyles, state) => ({
      ...baseStyles,
      width: '100%'
    }),
    control: (baseStyles, state) => {
      return ({
        ...baseStyles,
        borderRadius: state.menuIsOpen ? '20px 20px 0 0' : '32px',
        border: `1px solid ${borderColor}`,
        borderBottom: state.menuIsOpen ? 'none' : `1px solid ${borderColor}`,
        borderColor: error && '#F00',
        background: 'rgba(29, 41, 61, 0.75)',
        color: 'white',
        fontFamily: 'Exo',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        height: '50px',
        padding: '0 10px 0 20px',
        paddingBottom: state.menuIsOpen ? '2px' : 0,
        boxShadow: 'none',
        cursor: 'pointer',

        transition: 'border 0ms',
        '-webkit-transition': 'border 0ms',

        '&:hover': {
          borderColor: '#0CF'
        },

        '&:focus-within': {
          borderColor: '#0CF',
          backgroundColor: '#1D293D'
        },

        '&:focus-within ~ img': {
          transform: 'rotate(180deg)'
        }

      })
    },
    indicatorSeparator: (baseStyles, state) => ({
      ...baseStyles,
      width: 0
    }),
    dropdownIndicator: (baseStyles, state) => {
      return ({
        ...baseStyles,
        padding: '10px',
        color: 'white',
        transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
        '&:hover': {
          opacity: 0.6,
          color: 'white'
        },
        '&>svg': {
          width: '30px',
          height: '30px'
        }
      })
    },
    valueContainer: (baseStyles, state) => ({
      ...baseStyles,
      padding: 0,
      color: 'white'
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: 'white'
    }),
    menu: (baseStyles, state) => {
      return ({
        ...baseStyles,
        marginTop: '-5px',
        borderRadius: '0 0 20px 20px',
        border: '1px solid #0CF',
        borderTop: 'none',
        background: '#1D293D',
        padding: ' 0 20px 0',
        boxShadow: 'none'
      })
    },
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      maxHeight: '150px',
      color: '#808080',
      paddingTop: 0,
      paddingBottom: '15px',

      '&::-webkit-scrollbar': {
        borderRadius: '3px',
        width: '6px'
      },

      '&::-webkit-scrollbar-track': {
        background: 'rgba(255, 255, 255, 0.10)',
        borderRadius: '10px'
      },

      '&::-webkit-scrollbar-thumb': {
        background: 'white',
        borderRadius: '4px'
      }
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      fontFamily: 'Exo',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      background: 'transparent',
      padding: '7px 0',
      cursor: 'pointer',

      '&:hover, &:active': {
        color: 'white',
        background: 'none'
      }
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      color: 'white'
    })
  })
}


export { CustomStyles }
